import type {
  MobilePlanOffer,
  MobilePlanPartnerName,
} from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'

export function getSelectedMobilePlan(
  items: CartItem[],
  options?: {
    partnerName?: MobilePlanPartnerName
    type?: MobilePlanOffer['type']
  },
): MobilePlanOffer | undefined {
  const itemWithSelectedMobilePlan = items.find((item) => {
    if (!item.mobilePlan) return false

    if (
      options?.partnerName &&
      item.mobilePlan.selectedOffer.partner.name !== options.partnerName
    ) {
      return false
    }

    if (options?.type && item.mobilePlan.selectedOffer.type !== options.type) {
      return false
    }

    return true
  })

  return itemWithSelectedMobilePlan?.mobilePlan?.selectedOffer
}
